export default {
  functional: true,

  render(h, { children }) {
    const data = {
      props: {
        enterClass: 'opacity-0 scale-90',
        enterActiveClass: 'ease-out transition-fastest',
        enterToClass: 'opacity-100 scale-100',
        leaveClass: 'opacity-100 scale-100',
        leaveActiveClass: 'ease-in transition-fastest',
        leaveToClass: 'opacity-0 scale-90',
      },
    };

    return h('transition', data, children);
  },
};
